var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2422_41886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 1.33301L30.5 9.58301L26.375 10.333L22.25 9.58301L21.5 5.45801L22.25 1.33301Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 9.58301V1.33301H8.75C7.50688 1.33301 6.5 2.33988 6.5 3.58301V32.083C6.5 33.3261 7.50688 34.333 8.75 34.333H28.25C29.4931 34.333 30.5 33.3261 30.5 32.083V9.58301H22.25Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.083V24.958H26V14.083H11ZM17.5625 23.083H12.875V20.458H17.5625V23.083ZM17.5625 18.583H12.875V15.958H17.5625V18.583ZM24.125 23.083H19.4375V20.458H24.125V23.083ZM24.125 18.583H19.4375V15.958H24.125V18.583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2422_41886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4713f781f096f3e3f203d49c74d6a1a4.svg";
export { ForwardRef as ReactComponent };